import { FormattedMessage as FM } from "react-intl";

import BasicTable from "componentsv2/table/BasicTable";
import MsgInfo from "componentsv2/step/MsgInfo";
import CardTotal from "./CardTotal";
import { layout as layoutMoney } from "./ModelMoney";
import { useWizard } from "storev2/wizardStore";

function FormMoney() {
  const layout = layoutMoney();
  const { store } = useWizard();

  function onChangeRows() {
    let _total = 0;
    for (const value of store.money.values()) {
      _total += value.bill * value.quantity;
    }
    store.total.value = _total;
  }

  return (
    <div
      key="account-statement-step-money"
      className="flex h-full w-full overflow-auto px-3"
    >
      <div className="w-1/2 mt-5 overflow-scroll">
        {store?.money?.size > 0 && (
          <BasicTable
            layout={layout}
            records={store.money}
            triggerUpdate={onChangeRows}
          />
        )}
      </div>
      <div className="w-1/2 mt-12">
        <CardTotal total={store.total} />
        <div className="mt-12 px-12">
          <MsgInfo
            msg={
              <FM
                id="account.statement.close.msg_start"
                key="account_statement_close"
              />
            }
          />
        </div>
      </div>
    </div>
  );
}

export default FormMoney;
